import Popup from './src/popup';

export default Popup;



// WEBPACK FOOTER //
// ./packages/popup/index.js